<div class="table-wrapper" [ngClass]="{'dark-mode': darkMode, 'horizontal-scroll': enableHorizontalScroll}">
    <div class="table-body-wrapper" #tableBodyWrapper>
        <!-- Blocking overlays (60% black) when extra row is open - split to not cover selected row -->
        <!-- Top overlay: covers rows above selected row -->
        <div *ngIf="isExtraRowOpen && overlayTopHeight > 0"
             class="blocking-overlay blocking-overlay--top"
             [style.height.px]="overlayTopHeight"></div>

        <!-- Bottom overlay: covers rows below selected row -->
        <div *ngIf="isExtraRowOpen && overlayBottomHeight > 0"
             class="blocking-overlay blocking-overlay--bottom"
             [style.top.px]="overlayBottomTop"
             [style.height.px]="overlayBottomHeight"></div>

        <table [class]="tableClass">
            <thead>
                <tr>
                    <th *ngIf="showDragHandle" class="drag-handle-header" scope="col"
                        [class.sticky-col]="isDragHandleSticky" [style.left.px]="isDragHandleSticky ? 0 : null"></th>
                    <th class="drag-table-header" [ngClass]="'drag-table-header--' + column.field" *ngFor="let column of columns; let i = index; trackBy: trackByColumnField" scope="col"
                        [style.width]="column.width" [style.min-width]="enableHorizontalScroll ? column.width : column.minWidth" [style.max-width]="enableHorizontalScroll ? column.width : null"
                        [class.sticky-col]="isStickyColumn(i)" [style.left.px]="stickyLeftFor(i)">
                        {{ column.header }}
                        <ng-container *ngIf="column.field === 'batheTimeConfig' && enableBatheTimeHint && !isNyusho">
                            <i class="pi pi-question-circle last-updated-info__tooltip-icon tooltip-icon" tabindex="0"
                            [tooltipEvent]="tooltipShowEvent"
                            (pointerdown)="onTooltipIconPointerDown($event)" (click)="onTooltipIconTap($event)"
                            (mouseenter)="onTooltipIconShow()" (focus)="onTooltipIconShow()"
                            tooltipArrowAnchor
                            pTooltip="{{TEXT.BATH_TIME_CONFIG_HEADER_TOOLTIP}}" tooltipPosition="right" tooltipStyleClass="bathe-tooltip right-expand"></i>
                        </ng-container>
                    </th>
                    <th *ngIf="showEditColumn" class="edit-column-header" scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let processedRow of processedData; trackBy: trackByDaiCd"
                    pDraggable="table-row"
                    (onDragStart)="onDragStart($event, processedRow)"
                    (onDragEnd)="onDragEnd()"
                    [pDroppable]="['table-row', 'sidebar-main', 'sidebar-secondary', 'delete-zone']"
                    (onDrop)="onDropItem($event, processedRow.originalData)"
                    [ngClass]="{'dragging': draggedItem === processedRow.originalData, 'selected': selectedRow === processedRow.originalData, 'hovered': hoveredRow === processedRow.originalData, 'drag-disabled': !enableDragDrop}"
                    [pDraggableDisabled]="!isDragEnabled || !enableDragDrop"
                    [pDroppableDisabled]="!enableDragDrop"
                    (click)="onRowClick($event, processedRow.originalData)"
                    (mouseenter)="onRowMouseEnter(processedRow.originalData)"
                    (mouseleave)="onRowMouseLeave()">
                    <td *ngIf="showDragHandle" class="drag-handle-cell" [class.disabled]="!enableDragDrop"
                        [class.sticky-col]="isDragHandleSticky" [style.left.px]="isDragHandleSticky ? 0 : null"
                        (mouseenter)="enableDragDrop && enableDrag()" (mouseleave)="disableDrag()"
                        (pointerdown)="enableDragDrop && enableDrag()" (pointerup)="disableDrag()" (pointercancel)="disableDrag()"></td>
                    <td *ngFor="let column of columns; let i = index; trackBy: trackByColumnField" class="content-cell" [class]="'content-cell--' + column.field" [style.width]="column.width"
                        [style.min-width]="enableHorizontalScroll ? column.width : column.minWidth" [style.max-width]="enableHorizontalScroll ? column.width : null"
                        [class.sticky-col]="isStickyColumn(i)" [style.left.px]="stickyLeftFor(i)">
                        <ng-container *ngIf="column.field === 'name'; else checkPriority">
                            <div class="name-cell-content">
                                <span>{{ processedRow.cells.get(column.field) }}</span>
                                <div class="avatar-badge-wrapper">
                                    <div class="avatar-wrapper" [ngClass]="processedRow.genderClass">
                                        <img [id]="'avatar-' + processedRow.daiCd" [src]="processedRow.avatarUrl" [alt]="processedRow.cells.get(column.field)" class="avatar-img" (error)="onAvatarError(processedRow)">
                                        <span class="avatar-spinner" *ngIf="processedRow.avatarStatus === 'loading'" aria-hidden="true"></span>
                                    </div>
                                    <div class="short-term-badge" [class.visible]="processedRow.isShortTerm">
                                        <span>短</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #checkPriority>
                            <ng-container *ngIf="column.field === 'priority'; else checkBatheMethod">
                                <ng-container *ngIf="enablePriorityBadge; else plainPriority">
                                    <div class="priority-cell-content" *ngIf="processedRow.cells.get(column.field)">
                                        <span class="priority-badge" [ngClass]="getPriorityClass(processedRow.cells.get(column.field))">
                                            <div class="vertical-text">{{ processedRow.cells.get(column.field) }}</div>
                                        </span>
                                    </div>
                                </ng-container>
                                <ng-template #plainPriority>
                                    {{ processedRow.cells.get(column.field) }}
                                </ng-template>
                            </ng-container>
                        </ng-template>
                        <ng-template #checkBatheMethod>
                            <ng-container *ngIf="column.field === 'batheMethod' || column.field === 'bathMethodCd'; else checkBatheTimeConfig">
                                <span class="bathe-method-cell">{{ processedRow.cells.get(column.field) }}</span>
                            </ng-container>
                        </ng-template>
                        <ng-template #checkBatheTimeConfig>
                            <ng-container *ngIf="column.field === 'batheTimeConfig'; else checkLastBatheDate">
                                <ng-container *ngIf="!isNyusho; else defaultBatheTimeConfig">
                                    <div class="bathe-time-config-cell">
                                        <div class="bathe-time-config-cell__weeks">{{ processedRow.bathWeeksText }}</div>
                                        <div class="bathe-time-config-cell__days">{{ processedRow.bathDaysText }}</div>
                                    </div>
                                </ng-container>
                                <ng-template #defaultBatheTimeConfig>
                                    {{ processedRow.cells.get(column.field) }}
                                </ng-template>
                            </ng-container>
                        </ng-template>
                        <ng-template #checkLastBatheDate>
                            <ng-container *ngIf="column.field === 'lastBatheDate'; else checkTreatmentNotes">
                                <div class="last-bathe-date-cell">
                                    <div class="last-bathe-date-cell__date">{{ processedRow.lastBatheDateFormatted }}</div>
                                    <div class="last-bathe-date-cell__days">{{ processedRow.lastBatheDaysAgo }}</div>
                                </div>
                            </ng-container>
                        </ng-template>
                        <ng-template #checkTreatmentNotes>
                            <ng-container *ngIf="column.field === 'treatmentNotes'; else checkRemarks">
                                <div class="treatment-notes-cell">
                                    <caremoni-text-marquee
                                        [data]="{ message: processedRow.cells.get(column.field) }"
                                        [config]="{ width: '100%', height: '100%', highlight: false, minWidth: '-webkit-fill-available' }">
                                    </caremoni-text-marquee>
                                </div>
                            </ng-container>
                        </ng-template>
                        <ng-template #checkRemarks>
                            <ng-container *ngIf="column.field === 'remarks'; else defaultCell">
                                <div class="remarks-cell">
                                    <caremoni-text-marquee
                                        [data]="{ message: processedRow.cells.get(column.field) }"
                                        [config]="{ width: '100%', height: '100%', highlight: true, minWidth: '-webkit-fill-available' }">
                                    </caremoni-text-marquee>
                                </div>
                            </ng-container>
                        </ng-template>
                        <ng-template #defaultCell>
                            {{ processedRow.cells.get(column.field) }}
                        </ng-template>
                    </td>
                    <td *ngIf="showEditColumn" class="edit-column-cell">
                        <img src="assets/icons/edit-pencil.svg" alt="Edit" class="edit-icon" (click)="onEditIconClick($event, processedRow.originalData)">
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Dropzone overlay for external drags -->
        <div *ngIf="showDropzone && enableDragDrop"
             class="dropzone-overlay"
             [style.top.px]="dropzoneTop"
             [style.height.px]="dropzoneHeight"
             [style.left.px]="dropzoneLeft"
             [style.width]="dropzoneWidth"
             [pDroppable]="['sidebar-main', 'sidebar-secondary']"
             (onDrop)="onDropItem($event, null)">
            <div class="dropzone-content">
                <div class="dropzone-icon">
                    <i class="pi pi-upload"></i>
                </div>
                <div class="dropzone-text">ここにドロップ</div>
            </div>
        </div>

        <!-- Extra row overlay -->
        <div *ngIf="selectedRow" class="extra-row-overlay" [class.closing]="isExtraRowClosing" [style.top.px]="extraRowTop" [style.left.px]="extraRowLeft">
            <div class="extra-row-content">
                <!-- Custom template if provided -->
                <ng-container *ngIf="extraRowTemplate || extraRowContentTemplate">
                    <ng-container
                        *ngTemplateOutlet="(extraRowTemplate || extraRowContentTemplate)!; context: {$implicit: selectedRow, row: selectedRow}"></ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>
